<template>
  <div>
    <job-label :job="item.job" v-if="item.job"></job-label>
    <br />
    <strong>Claim Reference</strong>
    <br />
    {{ item.job?.reference || 'Not Provided' }}
    <br />
    <strong>Time</strong>
    <br />
    <template v-if="item.job?.start_time && item.job?.end_time">
      {{ item.job?.start_time | time }} - {{ item.job?.end_time | time }}
    </template>
    <template v-else>
      Not Provided
    </template>
    <br />
    <strong>Location</strong>
    <br />
    {{ item.job?.location }}
    <template v-if="item.job?.vehicle">
      <br />
      <strong>Vehicle</strong>
      <br />
      <span v-if="item.job?.vehicle?.make"
        >{{ item.job?.vehicle?.make?.label }} -
      </span>
      <span v-if="item.job?.vehicle?.model"
        >{{ item.job?.vehicle?.model }} -
      </span>
      {{ item.job?.vehicle?.registration }}
    </template>
    <template v-if="item.job?.client">
      <br />
      <strong>Client Name</strong>
      <br />
      {{ item.job?.client?.full_name || 'Not Provided' }}
      <br />
      <strong>Client Phone Number</strong>
      <br />
      {{ telephoneNumber || 'Not Provided' }}
      <br />
      <strong>Documents Signed?</strong>
      <br />
      <envelope-status-badge :job="item.job" :status="envelopeStatus" />
    </template>
  </div>
</template>

<script>
import JobLabel from '@/components/Modules/Shared/JobLabel';
import EnvelopeStatusBadge from '@/components/Modules/Shared/EnvelopeStatusBadge';

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },

  components: {
    JobLabel,
    EnvelopeStatusBadge
  },

  computed: {
    telephoneNumber() {
      switch (this.item.job?.client?.contact_method?.name) {
        case 'mobile_telephone':
          return this.item.job?.client?.mobile_telephone;

        case 'home_telephone':
          return this.item.job?.client?.home_telephone;

        case 'work_telephone':
          return this.item.job?.client?.work_telephone;

        default:
          return this.item.job?.client?.mobile_telephone;
      }
    },
    envelopeStatus() {
      return this.item.job?.envelopes[0]?.status;
    }
  }
};
</script>
